import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from '@emotion/styled';
import { N100A, N800 } from '@atlaskit/theme/colors';
import { gridSize } from '@atlaskit/theme/constants';
import { token } from '@atlaskit/tokens';
export var Content = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-top: ", "px;\n"])), function (_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled ? token('color.text.disabled', N100A) : token('color.text.highEmphasis', N800);
}, gridSize() / 2);